import React from 'react';

interface FindExactToggleProps {
  active: boolean;
  onToggle: (active: boolean) => void;
  tooltip: string;
}

const FindExactToggle: React.FC<FindExactToggleProps> = ({active, onToggle, tooltip}) => {
  return (
    <button
      type="button"
      className={`find-exact-toggle ${active ? 'active' : ''}`}
      onClick={() => onToggle(!active)}
      title={tooltip}
      aria-label={tooltip}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="16"
        height="16"
        fill="currentColor"
      >
        <path
          d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
        <path d="M12 7H7v2h5V7zm0 3H7v2h5v-2zm0 3H7v2h5v-2z" opacity=".3"/>
      </svg>
    </button>
  );
};

export default FindExactToggle;
